<template>
  <div>
    <div class="space-y-4">
      <div class="flex justify-end">
        <BaseButton @click="addVisible = true">Tambah</BaseButton>
      </div>

      <Datatable
        :total="officeExpeditions.meta.page.total"
        :perPage="officeExpeditions.meta.page.perPage"
        :currentPage="officeExpeditions.meta.page.currentPage"
        @pagechanged="onChangePageData"
        :columns="[
          { id: 'epxedition_code', name: 'Kode' },
          { id: 'epxedition_name', name: 'Nama' },
          { id: 'epxedition_detail', name: 'Alamat' },
          { id: 'action', name: 'Aksi' },
        ]"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="officeExpedition in officeExpeditions.data"
            :key="officeExpedition.id"
            :class="classes.tr"
          >
            <td :class="classes.td">{{ officeExpedition.attributes.code }}</td>
            <td :class="classes.td">{{ officeExpedition.attributes.name }}</td>
            <td :class="classes.td">
              <p>
                {{
                  getSingleIncluded(
                    officeExpeditions,
                    officeExpedition.relationships['expedition-detail'].data.id
                  ).attributes.address
                }}
              </p>
              <p>
                {{
                  getSingleIncluded(
                    officeExpeditions,
                    officeExpedition.relationships['expedition-detail'].data.id
                  ).attributes.phone[0]
                }}
              </p>
            </td>
            <td :class="classes.td">
              <BaseButton
                class="text-red-600 hover:text-red-700"
                for-icon
                @click="onDeleteOpen(officeExpedition)"
              >
                <Icon icon="heroicons:trash-solid" />
              </BaseButton>
            </td>
          </tr>
        </template>
      </Datatable>
    </div>

    <BaseModal
      :showing="addVisible"
      @close="addVisible = false"
      @opened="onAddOpened"
    >
      <BaseCard :with-style="false" title="Tambah Ekspedisi">
        <form class="space-y-4" @submit.prevent="onAddSubmit">
          <BaseInput label="Pilih Ekspedisi">
            <BaseSelect
              expand
              :shadow="false"
              :options="expeditionOptions"
              v-model="form.expedition"
              required
            />
          </BaseInput>
          <BaseInput
            type="text"
            label="No. Telp"
            fullwidth
            :shadow="false"
            placeholder="No. Telp"
            v-model="form.phone"
            required
          />
          <BaseInput
            tag="textarea"
            rows="4"
            label="Alamat"
            fullwidth
            :shadow="false"
            placeholder="Alamat"
            v-model="form.address"
            required
          />
          <div class="flex gap-2">
            <BaseButton :loading="loadingSubmit">Simpan</BaseButton>
            <BaseButton color="light">Batal</BaseButton>
          </div>
        </form>
      </BaseCard>
    </BaseModal>

    <BaseConfirm
      :visible="deleteConfirm.visible"
      icon-type="badge"
      title="Hapus Ekspedisi"
      message="Konfirmasi hapus ekspedisi"
      confirm-text="Hapus"
      @confirmed="onDeleteConfirm"
      @close="deleteConfirm.visible = false"
    />

    <Loading v-if="loadingData || loadingDelete" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { requestMixin } from '../../mixins/request/request';
import BaseModal from '../base/BaseModal.vue';
import BaseConfirm from '../base/BaseConfirm.vue';

export default {
  mixins: [requestMixin],
  components: { BaseModal, BaseConfirm },
  data() {
    return {
      expeditions: {
        data: [],
      },
      officeExpeditions: {
        data: [],
        meta: {
          page: {},
        },
      },
      form: {
        expedition: null,
        phone: null,
        address: null,
      },
      loadingData: true,
      loadingSubmit: false,
      loadingDelete: false,
      addVisible: false,
      deleteConfirm: {
        id: null,
        visible: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    expeditionOptions() {
      return [
        {
          key: null,
          label: 'Pilih Ekspedisi',
          value: null,
        },
        ...this.expeditions.data.map((expedition) => ({
          key: expedition.id,
          label: expedition.attributes.name,
          value: expedition.id,
        })),
      ];
    },
  },
  methods: {
    async loadExpeditions() {
      const [res, err] = await this.request(`/api/v1/expeditions`, {
        params: {
          'page[size]': 50,
          'sort': 'name'
        },
      });

      if (!err) {
        this.expeditions = res;
      }
    },
    async loadOfficeExpeditions(params = {}) {
      this.loadingData = true;

      const [res, err] = await this.request(
        `/api/v1/offices/${this.me.office_id}/office-expeditions`,
        {
          params: {
            'page[size]': 5,
            sort: '-id',
            include: 'expedition-detail',
            ...params,
          },
        }
      );

      if (!err) {
        this.officeExpeditions = res;
      }

      this.loadingData = false;
    },
    onChangePageData(page) {
      this.loadOfficeExpeditions({ 'page[number]': page });
    },
    onAddOpened() {
      this.form.expedition = null;
      this.form.phone = null;
      this.form.address = null;
    },
    onDeleteOpen(officeExpedition) {
      this.deleteConfirm.id = officeExpedition.id;
      this.deleteConfirm.visible = true;
    },
    async onDeleteConfirm() {
      this.loadingDelete = true;

      const [, err] = await this.request(
        `/api/v1/office-expeditions/${this.deleteConfirm.id}`,
        {
          method: 'delete',
        }
      );

      if (!err) {
        this.loadOfficeExpeditions();

        this.deleteConfirm.visible = false;
      }

      this.loadingDelete = false;
    },
    async onAddSubmit() {
      this.loadingSubmit = true;

      const [res, err] = await this.request(`/api/v1/expedition-details`, {
        method: 'post',
        data: {
          data: {
            type: 'expedition-details',
            attributes: {
              phone: [this.form.phone],
              address: this.form.address,
            },
            relationships: {
              expedition: {
                data: {
                  type: 'expeditions',
                  id: this.form.expedition,
                },
              },
            },
          },
        },
      });

      if (!err) {
        const [, err] = await this.request(
          `/api/v1/office-expeditions/-actions/attachToExpedition`,
          {
            method: 'post',
            data: {
              data: {
                type: 'office-expeditions',
                attributes: {
                  is_active: true,
                },
                relationships: {
                  expeditions: {
                    data: {
                      id: this.form.expedition,
                      type: 'expeditions',
                    },
                  },
                  'expedition-details': {
                    data: {
                      id: res.data.id,
                      type: 'expeditions-details',
                    },
                  },
                },
              },
            },
          }
        );

        if (!err) {
          this.addVisible = false;

          this.loadOfficeExpeditions();
        }
      }

      this.loadingSubmit = false;
    },
  },
  created() {
    this.loadExpeditions();
    this.loadOfficeExpeditions();
  },
};
</script>
